import { render, staticRenderFns } from "./edit-surcharge-list.vue?vue&type=template&id=9fd3c2ae&"
import script from "./edit-surcharge-list.vue?vue&type=script&lang=js&"
export * from "./edit-surcharge-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports